import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const BulkActionToolbar = ({ 
  selectedCount, 
  onComplete, 
  onDelete, 
  onMove, 
  onCancel 
}) => {
  return (
    <div className="fixed bottom-20 md:bottom-6 left-4 right-4 md:left-auto md:right-6 md:max-w-md z-[150] bg-card rounded-xl border border-border shadow-soft-xl p-4">
      <div className="flex items-center justify-between mb-3">
        <div className="flex items-center gap-2">
          <div className="w-8 h-8 rounded-lg bg-primary/10 flex items-center justify-center">
            <Icon name="CheckSquare" size={18} color="var(--color-primary)" />
          </div>
          <span className="text-sm md:text-base font-medium text-foreground">
            {selectedCount} {selectedCount === 1 ? 'task' : 'tasks'} selected
          </span>
        </div>
        <button
          onClick={onCancel}
          className="w-8 h-8 rounded-lg hover:bg-muted flex items-center justify-center transition-colors"
          aria-label="Cancel selection"
        >
          <Icon name="X" size={18} color="var(--color-muted-foreground)" />
        </button>
      </div>

      <div className="grid grid-cols-3 gap-2">
        <Button
          variant="outline"
          size="sm"
          onClick={onComplete}
          iconName="Check"
          iconPosition="left"
          iconSize={16}
          className="text-xs md:text-sm"
        >
          Complete
        </Button>

        <Button
          variant="outline"
          size="sm"
          onClick={onMove}
          iconName="Move"
          iconPosition="left"
          iconSize={16}
          className="text-xs md:text-sm"
        >
          Move
        </Button>

        <Button
          variant="destructive"
          size="sm"
          onClick={onDelete}
          iconName="Trash2"
          iconPosition="left"
          iconSize={16}
          className="text-xs md:text-sm"
        >
          Delete
        </Button>
      </div>
    </div>
  );
};

export default BulkActionToolbar;